import { Route, Routes } from 'react-router-dom';
import AdminReferences from './AdminReferences';
import AdminReferencesDetails from './AdminReferencesDetails';

export const AdminReferencesRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<AdminReferences />} />
    </Routes>
  );
};

export const AdminReferencesDetailsRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<AdminReferencesDetails />} />
    </Routes>
  );
};
